module.exports = __webpack_public_path__ + "static/media/dtme-2024.b467cb35.png";